import * as React from "react";
const SvgFiRrGlobeSnow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-globe-snow_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-1a4 4 0 0 0-1.991-3.458A10.9 10.9 0 0 0 23 11c0-6.065-4.935-11-11-11S1 4.935 1 11c0 2.853 1.072 5.517 2.992 7.542A4 4 0 0 0 2 22H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2M12 2c4.963 0 9 4.038 9 9a8.92 8.92 0 0 1-3.349 7H13v-2h1.641c.843 0 1.325-.963.819-1.637L14.438 13h.295a.888.888 0 0 0 .71-1.421L13.029 8.36a1.238 1.238 0 0 0-1.98 0l-2.414 3.219A.888.888 0 0 0 9.345 13h.218l-1.022 1.363A1.023 1.023 0 0 0 9.36 16h1.641v2H6.349a8.92 8.92 0 0 1-3.348-7C3 6.038 7.037 2 12 2M6 20h12c1.103 0 2 .897 2 2H4c0-1.103.897-2 2-2m7-14.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 13 5.5m4 5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 17 10.5M6.5 10a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-globe-snow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGlobeSnow;
